import React, { useMemo } from "react";

import {
  CardHeader,
  Card,
  CardContent,
  LazyCoverImage,
  CardTitle,
} from "@greeter/matter";
import {
  getDiscountedPrice,
  getPrice,
  ImageAsset,
  Product,
  Venue,
} from "@greeter/core";
import {
  BookRoute,
  CreateBookingV2Route,
  Tab,
} from "@greeter-guest/utility/Routes";
import { classNames } from "@greeter/util";

import css from "./TablePackageCard.module.scss";
import { useIonRouter } from "@ionic/react";
import { useDetectTab } from "@greeter-guest/hooks";

export type TablePackageCardProps = {
  className?: string;
  product: Product;
  venue: Venue;
};

export function TablePackageCard({
  className,
  product,
  venue,
}: TablePackageCardProps) {
  const router = useIonRouter();
  const tab = useDetectTab();
  const price = useMemo(() => getPrice(product), [product]);

  return (
    <Card
      {...classNames(css.Card, className)}
      onClick={() =>
        router.push(
          BookRoute.get(tab).route({
            venueId: venue.id,
            productId: product.id,
          }),
          "forward",
          "push"
          //{ unmount: true }
        )
      }
    >
      <CardHeader style={{ aspectRatio: "4/3" }}>
        <LazyCoverImage
          src={
            product.coverAsset
              ? ImageAsset.findUriWithSizeOrDefault(
                  product.coverAsset,
                  "4x3-w512"
                )
              : product.coverUrl ?? ""
          }
        />
      </CardHeader>
      <CardContent className={css.CardContent}>
        <CardTitle size="sm" className={css.CardTitle}>
          {product.title}
        </CardTitle>
        {/*<div className={css.CardTitle}>{product.title}</div>*/}
        {/*<div className={css.CardSubtitle}>{product.subTitle}</div>*/}
        <hr />
        <div className={css.Footer}>
          <div className={css.Price}>
            {product.discountPercentage &&
            product.discountPercentage > 0 &&
            price.type !== "discounted" ? (
              <>
                <s>{product.price}</s> {getDiscountedPrice(product)} kr.
              </>
            ) : null}
            {price.type === "discounted" && (
              <>
                <s>{price.price}</s> {price.discountedPrice} kr.
              </>
            )}
            {(price.type === "special" || price.type === "regular") &&
              product.discountPercentage === 0 && <>{price.price} kr.</>}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
